import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';

// onCreated(geoJson, areaSqMeters)
export default function DrawControl({ onCreated, existingPath }) {
  const map = useMap();
  const onCreatedRef = useRef(onCreated);
  onCreatedRef.current = onCreated;

  useEffect(() => {
    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);

    // Pre-load existing polygon for editing
    if (existingPath) {
      try {
        const points = typeof existingPath === 'string' ? JSON.parse(existingPath) : existingPath;
        const latlngs = points.map((p) => [p.latitude, p.longitude]);
        if (latlngs.length >= 3) {
          const polygon = L.polygon(latlngs, { color: '#ffffff', fillColor: '#ffffff', fillOpacity: 0.15, weight: 2 });
          drawnItems.addLayer(polygon);
          map.fitBounds(polygon.getBounds(), { padding: [20, 20], animate: false });
        }
      } catch {}
    }

    const circleIcon = new L.DivIcon({
      className: '',
      html: '<div style="width:10px;height:10px;border-radius:50%;background:#fff;border:2px solid rgba(255,255,255,0.8);box-shadow:0 0 4px rgba(0,0,0,0.5)"></div>',
      iconSize: [10, 10],
      iconAnchor: [5, 5],
    });

    const drawControl = new L.Control.Draw({
      position: 'topleft',
      edit: { featureGroup: drawnItems },
      draw: {
        polygon: {
          allowIntersection: false,
          showArea: true,
          shapeOptions: { color: '#ffffff', fillColor: '#ffffff', fillOpacity: 0.15, weight: 2 },
          icon: circleIcon,
          touchIcon: circleIcon,
          minPoints: 3,
        },
        polyline: false,
        rectangle: false,
        circle: false,
        marker: false,
        circlemarker: false,
      },
    });
    map.addControl(drawControl);

    const handleCreated = (e) => {
      drawnItems.clearLayers();
      drawnItems.addLayer(e.layer);
      const geoJson = e.layer.toGeoJSON();
      const latlngs = e.layer.getLatLngs()[0];
      const areaSqMeters = L.GeometryUtil.geodesicArea(latlngs);
      onCreatedRef.current?.(geoJson, areaSqMeters);
    };

    map.on(L.Draw.Event.CREATED, handleCreated);

    return () => {
      map.removeControl(drawControl);
      map.removeLayer(drawnItems);
      map.off(L.Draw.Event.CREATED, handleCreated);
    };
  }, [map]);

  return null;
}
